import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Stack, Snackbar, Slide } from "@mui/material";
import Alert from "@mui/material/Alert";
import { clearNotifications } from "../../redux/slices/notificationSlice";

const NotificationSnackbar = () => {
  const dispatch = useDispatch();
  const { open, notifications } = useSelector(
    (state) => state.notification
  );

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    dispatch(clearNotifications());
  };
  return (
    <Stack
      spacing={7} 
      sx={{ 
        maxWidth: 600,
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1400,
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}
    >
      {
        notifications.map((n, index) => {
          let {message} = n;
          if(message === undefined) {
            message = 'An error occured.';
          }
          return (
          <Slide key={index} direction="down" in={open} mountOnEnter unmountOnExit>
            {Boolean(message) && <Snackbar
              key={'notification' + Math.floor(Math.random()*100)}
              open={open && Boolean(message)}
              autoHideDuration={6000}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert
                onClose={handleClose}
                severity={n.severity}
                variant="filled"
              >
                {message || 'An error occured.'}
              </Alert>
            </Snackbar>}
          </Slide>
        )}
      )}
    </Stack>

  );
};

export default NotificationSnackbar;
